
<div class="content-wrap">
    <div id="content" class="content admin_tool_content">
        <div class="row">
            <div class="col-md-12">
                <h1 class="page-title pl0 pb10">Subscription Discount<span class="fw-semi-bold"></span></h1>
                <section class="widget overflow-auto pt30">
                    <div class="widget-body">
                        <form class="form-horizontal" role="form">
                            <fieldset>
                                <div class="form-group">
                                    <label for="normal-field" class="col-sm-3 control-label">Subscription type</label>
                                    <div class="dropdown display-inline ml10">
                                        <button class="btn dropdown-toggle btn-default" type="button"
                                            data-toggle="dropdown">
                                            <span class="pr5">{{subscription_value}}</span>
                                            <span class="caret"></span>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li (click)="changeSubscriptionType('arc_essentials', 'Arc essentials')"
                                                class="energy_unit"><a>Arc essentials</a></li>
                                            <li (click)="changeSubscriptionType('performance_certificate', 'Arc performance certificate')"
                                                class="energy_unit"><a>Arc performance certificate</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="subscription_type == 'arc_essentials'">
                                    <label for="normal-field" class="col-sm-3 control-label">User email</label>
                                    <div class="col-sm-7" [ngClass]="loader ? 'not-active' : ''">
                                        <input (input)=checkInputs() [(ngModel)]="username" type="text"
                                            class="form-control" placeholder="User email">
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="subscription_type == 'arc_essentials'">
                                    <label for="normal-field" class="col-sm-3 control-label">Number of users
                                        (subscriptions)</label>
                                    <div class="col-sm-7" [ngClass]="loader ? 'not-active' : ''">
                                        <input (input)=checkInputs() [(ngModel)]="count" class="form-control"
                                            placeholder="# of users">
                                    </div>
                                </div>
                                <div class="form-group" *ngIf="subscription_type == 'performance_certificate'">
                                    <label for="normal-field" class="col-sm-3 control-label">Project Id</label>
                                    <div class="col-sm-7" [ngClass]="loader ? 'not-active' : ''">
                                        <input (input)=checkInputs() [(ngModel)]="leed_id" class="form-control"
                                            placeholder="Project Id">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="normal-field" class="col-sm-3 control-label">Number of months</label>
                                    <div class="col-sm-7" [ngClass]="loader ? 'not-active' : ''">
                                        <input (input)=checkInputs() [(ngModel)]="months" class="form-control"
                                            placeholder="# of months">
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-sm-3 control-label" for="prepended-input"></label>
                                    <div class="col-sm-7" [ngClass]="loader ? 'not-active' : ''">
                                        <button (click)="saveStatus()" [ngClass]="valid_inputs ? '' : 'not-active'"
                                            class="btn btn-default pull-left mr10"><i class="icon-save"
                                                aria-hidden="true"></i> Save</button>
                                        <div *ngIf="loader" class="dataInputLoaderSpinner pull-left"></div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>